import { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { clearFilterData, initFilterData } from "./initData"
import { BoxFC, BoxFR } from "components/BoxCustom"
import { Box, TextField, Typography } from "@mui/material"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import { jobOrderColNm } from "constants/jobOrderConstant"
import { DesktopDatePicker } from "@mui/x-date-pickers-pro"
import SearchButton from "components/buttons/SearchButton"
import ClearButton from "components/buttons/ClearButton"
import ComboBox from "components/ComboBox"
import { goNexColumns, nwColumns, nwSummaryColumns } from "./columns"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { addIdForDataGrid, sortObjByDteTm } from "utils"
import dayjs from "dayjs"
import { endAdornmentProps } from "utils/bahtProps"


const NoWorkTruck = () => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [nexDataTable, setNexDataTable] = useState([])
  const [nwDataTable, setNwDataTable] = useState([])
  const [filterDist, setFilterDist] = useState("")
  
  const nwSummaryTable = useMemo(() => {
    const summary = {}
    const filterData = filterDist ? nwDataTable.filter(r => +r.Dist <= +filterDist): nwDataTable
    for (const row of filterData) {
      if (!summary[row.TukId]) {
        summary[row.TukId] = { 
          ...row,
          Num: 0,
          DteDist: []
        }
      }
      summary[row.TukId].Num++
      summary[row.TukId].DteDist.push({...row})
    }
    const summaryArr = []
    for(const row of Object.values(summary)){
      sortObjByDteTm(row.DteDist, "TukDte")
      summaryArr.push({
        ...row,
        TotalDist: row.DteDist.reduce((a,b)=>a+ +b.Dist,0).toString(),
        DteDistStr: row.DteDist.map(d=>`${dayjs(d.TukDte).format("DD")} (${d.Dist} กม.)`).join(", ")
      })
    }
    sortObjByDteTm(summaryArr, "LicNm")
    for(let i=0; i<summaryArr.length; i++){
      summaryArr[i].No = i+1
      summaryArr[i].id = summaryArr[i].TukId
    }
    return summaryArr
  }, [nwDataTable, filterDist])

  const monthPickerProp = useMemo(() => ({
    openTo: "month",
    views: ["year", "month"],
    disableMaskedInput: true,
    label: "รอบเดือน",
    inputFormat: "MMMM YYYY",
    value: filterData.TukTm,
    onChange: (newValue) => { setFilterData(o => ({ ...o, TukTm: newValue })) },
    renderInput: (params) => <TextField size="small" {...params} sx={{ width: 160 }} required />,

  }), [filterData.TukTm])

  const getData = useCallback((filter) => {
    const postData = {
      ...filter,
      TukTmSt: filter.TukTm.startOf("month").format("YYYY-MM-DD"),
      TukTmEn: filter.TukTm.endOf("month").format("YYYY-MM-DD 23:59:59.997"),
    }
    ax.post("/branch/getNexInOut", postData).then(value => {
      if (value.data) {
        setNexDataTable(addIdForDataGrid(value.data.nexInOut, "NEXInOutId"))
        const tukNoWorkData = []
        let no = 0
        for (const row of value.data.tukNoWork) {
          no++
          tukNoWorkData.push({
            ...row,
            No: no,
            id: no,
            Dist: row.Dist.toString()
          })
        }
        setNwDataTable(tukNoWorkData)
      }
    })
  }, [ax])

  const handleButtonSearchClick = useCallback(() => {
    getData(filterData)
  }, [filterData, getData])

  const handleButtonClearClick = useCallback(() => {
    setFilterData({ ...clearFilterData })
  }, [])
  
  useEffect(()=>{
    getData({...initFilterData})
  }, [getData])
  return (
    <BoxFC sx={{ gap: 1 }} height="100%">
      <BoxFR>
        <Box flex={1} />
        <ComboBox sx={{ width: 150 }} options={msData.truckCombo} label={jobOrderColNm.LicNm}
          selectedId={filterData.TukId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, TukId: id }))}
        />
        <DesktopDatePicker {...monthPickerProp} />
        <SearchButton onClick={handleButtonSearchClick} />
        <ClearButton onClick={handleButtonClearClick} />
      </BoxFR>
      <BoxFR flex={1}>
        <BoxFC sx={{ gap: 1 }} height="100%" flex={1}>
          <Typography variant="h6">รายการรถเข้าศุนย์ NEX</Typography>
          <Box flex={1} >
            <DataGridCellExpand
              hideFooter
              rows={nexDataTable}
              columns={goNexColumns}
            />
          </Box>
          <BoxFR>
          <Typography variant="h6">สรุปรายการรถไม่วิงงาน</Typography>
          <TextField size="small" label="ระยะทางขั้นต่ำ " type="number" value={filterDist}
            onChange={e=>setFilterDist(e.target.value)} sx={{width: 160}} 
            {...endAdornmentProps("กม.")}/>
          </BoxFR>
          <Box flex={1} >
            <DataGridCellExpand
              hideFooter
              rows={nwSummaryTable}
              columns={nwSummaryColumns}
            />
          </Box>
        </BoxFC>
        <BoxFC sx={{ gap: 1 }} height="100%" width={550}>
          <Typography variant="h6">รายการรถไม่วิ่งงาน</Typography>
          <Box height="100%" >
            <DataGridCellExpand
              hideFooter
              rows={nwDataTable}
              columns={nwColumns}
            />
          </Box>
        </BoxFC>
      </BoxFR>
    </BoxFC>
  )
}

export default NoWorkTruck